<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M14.7544 6.28564H1.24578C0.605789 6.28564 0.331503 5.5885 0.834361 5.25707L7.58864 0.834209C7.71335 0.760851 7.8554 0.722168 8.00007 0.722168C8.14476 0.722168 8.2868 0.760851 8.4115 0.834209L15.1658 5.25707C15.6686 5.5885 15.3944 6.28564 14.7544 6.28564Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M14.858 12.5713H1.14369C0.828103 12.5713 0.572266 12.8272 0.572266 13.1427V14.857C0.572266 15.1725 0.828103 15.4284 1.14369 15.4284H14.858C15.1735 15.4284 15.4294 15.1725 15.4294 14.857V13.1427C15.4294 12.8272 15.1735 12.5713 14.858 12.5713Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.28711 6.28564V12.5714"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.0957 6.28564V12.5714"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.90625 6.28564V12.5714"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.7148 6.28564V12.5714"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
